import * as React from 'react';
import { getI18n } from 'services/i18n-service';
import { translations } from 'types/translations';

import './styles.css';
import { AlertErrorKey } from 'types/alert-error-key';
import { Epc } from 'types/epc';

export interface Props {
  epc: Epc;
  errorKey: string;
  alertReason: string;
  additionalMessage: string;
}

export const AlertMessage: React.StatelessComponent<Props> = (props) => {
  const i18n = getI18n();
  return (
    <span className="alert-content">
      {
        props.errorKey !== '' &&
        <>
          <p className="alert-error-key">
            <strong>{i18n.t(translations.ErrorCode)}</strong>: {props.errorKey}
          </p>
          <p className="alert-epc">
            {
              (props.errorKey === AlertErrorKey.InvalidEpc || props.errorKey === AlertErrorKey.ScannerConfig)
                ? <span><strong>{i18n.t(translations.Barcode)}</strong>: {props.epc.rawCode}</span>
                : <span>
                  <br />
                  <span><strong>{i18n.t(translations.ProductCode)}</strong>: {props.epc.productCode}</span>
                  <br />
                  <span><strong>{i18n.t(translations.SerialNumber)}</strong>: {props.epc.serialNumber}</span>
                  <br />
                  <span><strong>{i18n.t(translations.Status)}</strong>: {props.epc.status}</span>
                </span>
            }
          </p>
        </>
      }
      <p className="alert-reason">
        <strong>{i18n.t(translations.Reason)}</strong>: {props.alertReason}
      </p>
      {
        props.additionalMessage && props.additionalMessage !== ''
          ? <p className="alert-additional-message">
              {props.additionalMessage}
            </p>
          : null
      }
    </span>
  );
};


// WEBPACK FOOTER //
// ./src/components/alert/alert-content.tsx